import styled, { css } from 'styled-components';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid, GridItem } from '../Grid';
import Icon from '../Icon';

export const PaginationGrid = styled(GridItem)`
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery.tabletPortrait`
      justify-content: space-between;
  `}
`;

export const PaginationWrapper = styled(Grid)`
  && {
    margin-top: ${spacing(8)};
    margin-bottom: ${spacing(12)};
  }
`;

export const styledButton = css<{
  shownOnMobile?: boolean;
}>`
  border: none;
  display: ${({ shownOnMobile }) => (shownOnMobile ? 'flex' : 'none')};
  height: auto;
  width: auto;

  ${mediaQuery.tabletPortrait`
    display:flex;
  `}
`;

export const PageNumberWrapper = styled.div`
  display: flex;
`;

export const Dots = styled.div`
  ${styledButton}
  min-width: ${spacing(6)};
  align-items:center;
  justify-content: center;
  ${fonts.headingSmall}
`;

export const StyledIcon = styled(Icon)`
  margin: ${spacing(1)};
`;
